import { routeMap } from 'router/routes';

export default function (serverName, filename) {
  return {
    pathname: routeMap.openTapsPdf,
    query: { pdf: serverName, filename },
  };
}
